"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styles_1 = require("@material-ui/core/styles");

var useStyles = (0, styles_1.makeStyles)(function (theme) {
  return {
    momentBody: {
      background: theme.palette.background.default
    },
    simple: {
      boxShadow: theme.shadows[8],
      maxHeight: '70vh',
      maxWidth: '100%',
      objectFit: 'cover',
      width: '100%'
    },
    simpleGrid: {
      padding: theme.spacing(8)
    },
    simpleGridContainer: {
      maxHeight: '100vh',
      overflowY: 'scroll',
      paddingBottom: '30vh'
    }
  };
});
exports.default = useStyles;